import { render, staticRenderFns } from "./rental-limitation-per-week.vue?vue&type=template&id=5565317c&"
import script from "./rental-limitation-per-week.vue?vue&type=script&lang=js&"
export * from "./rental-limitation-per-week.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports